import PropTypes from 'prop-types';
import { PROFESSION_OPTIONS } from '../../../../../config/dataConfig/FJHeadshotGeneratorData';
import OptionCard from '../OptionCard';

import styles from './StepForm.module.less';
import FJLocalStore from '../../../../../store/FJLocalStore';
import FJConfig from '../../../../../config/FJConfig';
import { useMemo } from 'react';
import FJFileHandleUtil from '../../../../../util/FJFileHandleUtil';

const FJProfessionSelector = ({ selectedProfession, onProfessionChange, gender }) => {
    const professionOptions = useMemo(
        () => PROFESSION_OPTIONS.filter(profession => profession.gender === gender),
        [gender],
    );
    return (
        <div className={styles.step_form}>
            <h3 className={styles.step_title}>{FJLocalStore._('select-your-profession')}</h3>
            <div className={styles.options_grid}>
                {professionOptions.map(profession => (
                    <OptionCard
                        key={profession.key}
                        title={FJLocalStore._(profession.value)}
                        imageUrl={FJFileHandleUtil.getImageUrlWithFormat(
                            `${FJConfig.headshotImagePath}${profession.imageUrl}?v=${FJConfig.version}`,
                        )}
                        isSelected={selectedProfession.value === profession.value}
                        onClick={() => onProfessionChange(profession)}
                    />
                ))}
            </div>
        </div>
    );
};

FJProfessionSelector.propTypes = {
    selectedProfession: PropTypes.object,
    onProfessionChange: PropTypes.func,
    gender: PropTypes.string,
};

export default FJProfessionSelector;
